import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const TileCategory = ({
  // eslint-disable-next-line
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={23} width={26} viewBox="0 0 26 23" fill="none" {...props}>
    <g filter="url(#filter0_dii_3570_155427)">
      <path
        d="M1 0H18C21.866 0 25 3.13401 25 7V22H17C8.16344 22 1 14.8366 1 6V0Z"
        fill="url(#paint0_linear_3570_155427)"
      />
    </g>
    <g filter="url(#filter1_dii_3570_155427)">
      <path
        d="M11.1144 11.9084L14 12.75L14.3256 16.1685C14.3806 16.7465 15.1426 16.9171 15.4389 16.4178L18.4076 11.4149C18.7077 10.9092 18.4502 10.2563 17.8856 10.0916L15 9.25L14.6744 5.83146C14.6194 5.25351 13.8574 5.08288 13.5611 5.58216L10.5924 10.5851C10.2923 11.0908 10.5498 11.7437 11.1144 11.9084Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_dii_3570_155427"
        x="0.742979"
        y="0"
        width="24.514"
        height="22.757"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.5" />
        <feGaussianBlur stdDeviation="0.128511" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3570_155427" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3570_155427"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0" />
        <feBlend mode="normal" in2="shape" result="effect2_innerShadow_3570_155427" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          mode="normal"
          in2="effect2_innerShadow_3570_155427"
          result="effect3_innerShadow_3570_155427"
        />
      </filter>
      <filter
        id="filter1_dii_3570_155427"
        x="10.2089"
        y="5.28906"
        width="8.58228"
        height="12.1789"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.5" />
        <feGaussianBlur stdDeviation="0.128511" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3570_155427" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3570_155427"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.128511" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0" />
        <feBlend mode="normal" in2="shape" result="effect2_innerShadow_3570_155427" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0" />
        <feBlend
          mode="normal"
          in2="effect2_innerShadow_3570_155427"
          result="effect3_innerShadow_3570_155427"
        />
      </filter>
      <linearGradient
        id="paint0_linear_3570_155427"
        x1="22.6"
        y1="1.43307e-06"
        x2="2.09368"
        y2="11.8779"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF4D80" />
        <stop offset="1" stopColor="#B56DC6" />
      </linearGradient>
    </defs>
  </SvgIcon>
);
